import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SweetScroll from 'sweet-scroll'
import _ from 'lodash'
// ---
import Wrapper from '../../components/wrapper';
import './styles.css';
// ---
import FeatureCategoryContainer from "../feature-category-container";
import {convertPipeToBrTag} from "../../utils";
import PickerContainer from '../picker-container';

import ScrollLoader from '../../components/scroll-loader';

// カテゴリのデフォルトコンテント設定に使用する
const DEFAULT_FILTER_ID = 'first-0';

// ---------------------------------------------------------------
// const handlers = [];
// const tick = () => {
//   const tickId = requestAnimationFrame(tick);
//   handlers.map(handle => (handle.call(this, tickId)));
// };
//
// class FilterScrollSmooth {
//   constructor(element) {
//     this.element = element;
//     this.update = this.update.bind(this);
//     this.step = 0;
//     this.targetLeft = 0;
//     this.goal = 0;
//     this.option = {};
//     this.prevLeft = -1;
//   }
//   init() {
//     tick();
//   }
//   add() {
//     handlers.push(this.update);
//   }
//   remove() {
//     handlers.shift();
//   }
//   to(scrollLeft, option) {
//     this.remove();
//     const currentLeft = this.element.scrollLeft;
//     let targetLeft = scrollLeft;
//     this.goal = Math.floor(targetLeft);
//     if (this.goal < 0) {
//       targetLeft -= this.goal;
//       this.goal = 0;
//     }
//     this.targetLeft = targetLeft;
//     this.option = option;
//     this.step = (targetLeft - currentLeft) * 0.1;
//     this.prevLeft = -1;
//     this.add();
//   }
//   update() {
//     const currentLeft = this.element.scrollLeft;
//     // const willLeft = currentLeft + ((this.targetLeft - currentLeft) * (1 / 10));
//     const willLeft = currentLeft + ((this.targetLeft - currentLeft) * (1 / 6));
//     const absSub = Math.abs(currentLeft - this.prevLeft);
//     // if (absSub < 15) {
//     //   this.almostComplete();
//     // }
//     if (absSub < 1) {
//       this.complete();
//     } else if (this.prevLeft === currentLeft) {
//       this.complete();
//     } else if (this.step > 0) {
//       if (this.goal <= willLeft) {
//         this.complete();
//       } else {
//         this.refresh(willLeft);
//       }
//     } else if (this.goal >= willLeft) {
//       this.complete();
//     } else {
//       this.refresh(willLeft);
//     }
//     this.prevLeft = currentLeft;
//   }
//   almostComplete() {
//     if (typeof this.option.almostComplete === 'function') {
//       this.option.almostComplete.call(this);
//     }
//   }
//   complete() {
//     this.remove();
//     this.element.scrollLeft = this.goal;
//     if (typeof this.option.complete === 'function') {
//       this.option.complete.call(this);
//     }
//   }
//   refresh(scrollLeft) {
//     this.element.scrollLeft = scrollLeft;
//   }
// }
// ---------------------------------------------------------------
/**
 *  FeatureCategories
 */
export default class FeatureCategories extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.node),
    selectTextColor: PropTypes.string,
    layout: PropTypes.string,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
    readMoreLabel: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    categories: [],
    selectTextColor: 'Dark',
    layout: 'Horizontal',
    pcDisplayLine: 4,
    mbDisplayLine: 4,
    readMoreLabel: null,
  };
  
  /**
   *  filter - parent / child
   *  - child 選択時 他の child も同一グループなのをチェックする
   *  @param {string} parentName - 親名称 `first-0`
   *  @param {string} currentFilterId - 子名称 `first-0-second0`
   */
  static secondFilterContains(parentName, currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    const divideId = parentName.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  }
  
  /**
   * second filter id name 判定します ex. `first-0-second0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true second filter id
   */
  static isSecondFilterId(currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 3;
  }
  
  /**
   * first filter id name 判定します ex. `first-0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true first filter id
   */
  static isFirstFilterId(currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 2;
  }

  /**
   * second filter の先頭の ID check
   * @param {string} id 調査対象 ID
   * @returns {boolean} true: second first
   */
  static isFirstSecondFilterId(id) {
    if (!FeatureCategories.isSecondFilterId(id)) {
      return false;
    }
    // console.log('FeatureCategories.isFirstFilterId', id, id.split('-').pop(), id.split('-').pop().replace('second', ''));
    return parseInt(id.split('-').pop().replace('second', ''), 10) === 0;
  }
  static analyzeFilterId(id) {
    const firstFilterId = FeatureCategories.isFirstFilterId(id);
    const secondFilterId = FeatureCategories.isFirstFilterId(id);
    const secondFirstFilter = FeatureCategories.isSecondFilterId(id);
    return {
      firstFilterId,
      secondFilterId,
      secondFirstFilter,
    };
  }

  constructor(props) {
    super(props);
    // ---
    this.opacityZeroClassName = FeatureCategoryContainer.OPACITY_ZERO_CLASS_NAME;

    this.state = {
      currentFilterId: 'first-0',
      currentFilterMarkedId: 'first-0',
      containerIndex: 0,
      // for mb filter title
      filterTitle: '',
      filterSecondOpen: false,
      filterChangeOpacityClassName: this.opacityZeroClassName,
      //
      slickTransitionClassName: '',
    };
    // ---
    /**
     * props.categories を `FeatureCategoryContainer` のみ抽出し list する
     * @type {{first: Array, second: Array, concat: ?Array}}
     */
    this.containers = {
      first: [],
      second: [],
      concat: [],
    };
    this.timer = {
      titleCenter: 0,
      titleCenterSequence: 0,
    };
    /**
     * props.categories を {@link getComponents} を通す - props.categories 使用しない
     * @type {Array<*>}
     */
    // this.categories = this.convertPropsCategories();
    this.categories = props.categories || [];
    // カテゴリのデフォルトコンテント設定を行う
    this.parseDefaultCategoryContent(this.categories, DEFAULT_FILTER_ID)

    this.onTitleClickCaller = this.onTitleClickCaller.bind(this);
    this.resetSliderCount = 0;
    // ---
    this.abortSlickTransitionClassName = FeatureCategoryContainer.ABORT_SLICK_TRANSITION;
    // this.slickTransitionZero = false;
    this.slickThumbnailChangedCallback = this.slickThumbnailChangedCallback.bind(this);
    // ---
    this.refFilterFirst = null;
    this.refFilterFirstWrap = null;
    this.filterFirstTitles = {};
    this.abortOpacityZero = this.abortOpacityZero.bind(this);
    this.onResize = this.onResize.bind(this);
    this.currentFilterId = this.state.currentFilterId;
    // this.changeState = null;
    this.changedFilter = false;
    // this.filterScrollSmooth = null;
    // this.onBlur = this.onBlur.bind(this);
    // this.filterComplete = false;
  }
  onResize() {
    // console.log('FeatureCategories.onResize', this.currentFilterId);
    this.titleMoveCenter(this.currentFilterId);
  }
  // onBlur() {
  //   if (this.filterScrollSmooth) {
  //     this.filterScrollSmooth.complete();
  //   }
  // }
  // --------------------------------------------------
  /**
   * filter title click callback
   * 各カテゴリをクリックしたときに呼ばれる
   * - 更新が必要なときは
   *   1. opacity: 0 します
   *   1. {@link FeatureCategories.titleMoveCenter} - mobile current を center 移動します
   * @param {string} id filter id - 現在 id と比較し更新が必要か判断します
   * @param {string} title filter title - mobile で current 表示に使用します
   */
  onTitleClickCaller(id, title) {
    const isFirstSecondFilterId = FeatureCategories.isFirstSecondFilterId(this.state.currentFilterId);
    const argIdIsFirst = FeatureCategories.isFirstFilterId(id);
    const currentFilterIdContainsId = FeatureCategories.secondFilterContains(id, this.state.currentFilterId);
    this.changedFilter = false;
    if (argIdIsFirst && currentFilterIdContainsId && isFirstSecondFilterId) {
      return;
    }
    // console.log('FeatureCategories.onTitleClickCaller', this.state.currentFilterId, id, this.state.currentFilterId !== id, 'arg, contains, first', argIdIsFirst, currentFilterIdContainsId, isFirstSecondFilterId);
    if (this.state.currentFilterId !== id) {
      this.changedFilter = true;
      // ---
      this.currentFilterId = id;
      // this.enableOpacityZero();
      // ---
      // this.titleMoveCenter(id);
      // ---
      const changeState = {
        currentFilterId: id,
        easing: 'easeOutCubic',
        filterTitle: FeatureCategories.isSecondFilterId(id) ? title : '',
        filterSecondOpen: false,
        slickTransitionClassName: this.abortSlickTransitionClassName,
        filterChangeOpacityClassName: this.opacityZeroClassName,
      };
      // if (!this.state.filterChangeOpacityClassName) {
      //   changeState.filterChangeOpacityClassName = this.opacityZeroClassName;
      // }
      // this.setState(changeState);
      this.refreshStateWhenChangeFilterOnlyFilterCurrent(id, changeState);
      this.abortOpacityZero();
      // this.titleMoveCenter(id, changeState);
      setTimeout(() => {
        this.titleMoveCenter(id, changeState);
      }, 16);
    }
  }
  // --------------------------------------------------
  /**
   *
   * @param {string} id filter id - 位置を取得するのに使用します {@link FeatureCategories.filterFirstTitles}
   * @param {*} [changeState=null] 移動後に更新する state
   * @returns {*} 戻り値使用しない
   */
  titleMoveCenter(id, changeState = null) {
    // ---
    const innerWidth = window.innerWidth;
    if (innerWidth >= 768 || !this.refFilterFirst) {
      // 768 以上 desktop 処理
      return this.refreshStateWhenChangeFilter(changeState);
    }
    // -------------
    // 767 以下 MB 処理
    // ---
    const component = this.filterFirstTitles[id];
    if (!component || !component.getTitleClientRect) {
      return this.refreshStateWhenChangeFilter(changeState);
    }
    const rect = component.getTitleClientRect();
    if (!rect) {
      return this.refreshStateWhenChangeFilter(changeState);
    }
    const scrollLeft = this.refFilterFirst.scrollLeft;
    const center = innerWidth * 0.5;
    const middle = rect.left + (rect.width * 0.5);
    // console.log('FeatureCategories.titleMoveCenter', id, innerWidth, scrollLeft, center, middle, changeState);
    clearTimeout(this.timer.titleCenter);
    clearTimeout(this.timer.titleCenterSequence);
    this.sequenceTitleMoveCenter(center, middle, scrollLeft, changeState, rect);
  }

  /**
   * mobile - current title を center へ移動します
   * @param {number} center title container center 位置
   * @param {number} middle window center 位置
   * @param {number} scrollLeft scroll 位置
   * @param {ClientRect} rect component rectangular
   * @param {?*} changeState 移動後に更新する state
   */
  sequenceTitleMoveCenter(center, middle, scrollLeft, changeState, rect) {
    const subtract = middle - center;
    const expectMove = (scrollLeft + subtract);
    const wrapRect = this.refFilterFirstWrap.getBoundingClientRect();
    const wrapWidth = wrapRect.width;
    // const duration = 320;
    // 移動距離で duration 増減させる - 基準値 320ms per 140px
    const duration = Math.floor((Math.abs(scrollLeft - expectMove) / 140) * 320);
    // const duration = 960 * Math.sin(expectMove / window.innerWidth);
    const option = {
      duration,
      // easing: 'easeOutCubic',
      easing: 'easeOutSine',
      horizontal: true,
      horizontalScroll: true,
      cancellable: false,
      stopPropagation: false,
    };
    // // scroll 判定
    // if ((expectMove + scrollLeft) < wrapWidth) {
    //   option.completeScroll = () => {
    //     this.refreshStateWhenChangeFilter(changeState);
    //   };
    // } else {
    //   // 右端で移動できないときはすぐに更新させる
    //   this.refreshStateWhenChangeFilter(changeState);
    // }
    this.refreshStateWhenChangeFilter(changeState);
    // ------------------------------------------------
    const sweetScroll = new SweetScroll(option, this.refFilterFirst);
    sweetScroll.toLeft(expectMove);
    // ------------------------------------------------
    // original code での scroll - カクつくので使用しない
    // this.filterComplete = false;
    // this.filterScrollSmooth.to(
    //   expectMove,
    //   {
    //     // almostComplete: () => {
    //     //   if (!this.filterComplete) {
    //     //     this.filterComplete = true;
    //     //     this.refreshStateWhenChangeFilter(changeState);
    //     //     console.log('FeatureCategories.sequenceTitleMoveCenter.almostComplete');
    //     //   }
    //     // },
    //     complete: () => {
    //       this.refreshStateWhenChangeFilter(changeState);
    //       console.log('FeatureCategories.sequenceTitleMoveCenter.complete');
    //     },
    //   },
    // );
    // ------------------------------------------------
  }

  /**
   * カテゴリをクリックしたときに、onTitleClickCaller 関数内で呼ばれる
   * filter title `current` を下表示切り替えより先行させる state 切替
   * @param {string} id current filter id
   * @param {*} changeState React.state
   */
  refreshStateWhenChangeFilterOnlyFilterCurrent(id, changeState) {
    if (changeState) {
      // console.log('FeatureCategories.refreshStateWhenChangeFilterOnlyFilterCurrent', id);
      this.setState({ currentFilterMarkedId: id });
    }
  }
  /**
   * filter change 時に state 更新処理を行います
   * @param {*} changeState React.state
   */
  refreshStateWhenChangeFilter(changeState) {
    if (changeState) {
      this.setState(changeState);
    }
  }
  // --------------------------------------------------
  enableOpacityZero() {
    // document.body.classList.add(this.opacityZeroClassName);
    if (!this.state.filterChangeOpacityClassName) {
      this.setState({ filterChangeOpacityClassName: this.opacityZeroClassName });
    }
  }
  abortOpacityZero() {
    // document.body.classList.remove(this.opacityZeroClassName);
    // console.log('FeatureCategories.abortOpacityZero', this.currentFilterId, this.state.filterChangeOpacityClassName);
    if (this.state.filterChangeOpacityClassName === this.opacityZeroClassName) {
      this.setState({ filterChangeOpacityClassName: '' });
    }
  }
  // --------------------------------------------------
  /**
   * {@link FeatureCategoryContainer} から callback されます
   * - {@link FeatureCategories.abortSlickTransition} `.slick-track` transition-duration: 0s を解除します
   */
  slickThumbnailChangedCallback() {
    this.abortSlickTransition();
  }
  enableSlickTransition() {
    // document.body.classList.remove(this.abortTransitionClassName);
    // this.slickTransitionZero = true;
    if (!this.state.slickTransitionClassName) {
      this.setState({ slickTransitionClassName: this.abortSlickTransitionClassName });
    }
  }
  /**
   * `.slick-track` transition-duration: 0s を解除します
   */
  abortSlickTransition() {
    // this.slickTransitionZero = false;
    if (this.state.slickTransitionClassName === this.abortSlickTransitionClassName) {
      this.setState({ slickTransitionClassName: '' });
    }
  }
  // --------------------------------------------------
  // /**
  //  * {@link getComponents} を通し `null` 除外します
  //  * @returns {Array} filter 後の categories
  //  */
  // convertPropsCategories() {
  //     const { categories } = this.props;
  //     return Array.isArray(categories) ? getComponents(categories).filter(component => (component !== null)) : [];
  // }
  /**
   * props.categories をパースします
   * - 第一階層は `FeatureCategoryContainer` のみ
   * - 第二回層は `FeatureCategoryContainer` / ...etc - `FeatureCategoryContainer` のみに filter する
   */
  parseDefaultCategoryContent(categories = [], filterId) {
    const list = {
      first: [],
      second: [],
      concat: null,
    };
    categories.map((category, index) => {
      const step0 = `first-${index}`;
      // 第一階層は `FeatureCategoriesContainer` のみ
      list.first.push(
        {
          name: step0,
          parent: null,
          category,
        },
      );
      const components = Array.isArray(category.props.components) ? category.props.components: [];
      // 第二回層は `FeatureCategoriesContainer` / `...etc`
      // `FeatureCategoriesContainer` のみに filter する
      components.map((component, count) => {
        // console.log('FeatureCategories.parseCategoriesList.map', component);
        if (component.name === 'FeatureCategoryContainer') {
          const step1 = `${step0}-second${count}`;
          list.second.push(
            {
              name: step1,
              parent: step0,
              category: component,
            },
          );
        }
        return component;
      });
      return category;
    });

    // 初期ロード時のデフォルトコンテントを配列にする
    const defaultContent =
      _.filter(list.first, ({ name }) => _.includes(filterId, name) ||
        _.includes(name, filterId))

    // 選択したカレントカテゴリのコンテントを配列にする
    const selectedContent =
      _.filter(list.second, ({ parent }) => _.includes(filterId, parent) ||
        _.includes(parent, filterId))

    const syncedSelectedContent = selectedContent || []
    list.concat = [...defaultContent, ...syncedSelectedContent]

    this.containers = list
  }

  /**
   * 選択したメニューに応じて、カレントカテゴリを切り替える
   */
  getCurrentCategoryContent(categories, filterId) {
    // 選択したカレントカテゴリのコンテントを配列にする
    const selectedContent =
      _.filter(this.containers.second, ({ parent }) => _.includes(filterId, parent) ||
        _.includes(parent, filterId))

    const syncedSelectedContent = selectedContent || []
    this.containers.concat = [...this.containers.first, ...syncedSelectedContent]
  }

  /**
   * filter id が second list を持つか判定し index を返します
   * @param currentFilterID
   * @returns {{result: boolean, index: number}}
   */
  hasSecondItems(currentFilterID) {
    let index = -1;
    if (!FeatureCategories.isFirstFilterId(currentFilterID)) {
      return { result: false, index };
    }
    const { second } = this.containers;
    const result = second.some((data, i) => {
      if (data.parent === currentFilterID) {
        index = i;
        return true;
      }
      return false;
    });
    return {result, index};
  }
  
  /**
   * first filter selected - second filter exist の時は second filter first を active にするための対応
   * */
  shouldSecondFirstActivate() {
    // 選択 filter id が first で second が存在するかのチェック
    const {result, index} = this.hasSecondItems(this.state.currentFilterId);
    if (!result) {
      return;
    }
    const data = this.containers.second[index];
    if (data.name !== this.state.currentFilterId) {
      // console.log('FeatureCategories.shouldSecondFirstActivate changed', result, index, data.name, this.state.currentFilterId);
      this.setState({ currentFilterId: data.name, currentFilterMarkedId: data.name });
      return true;
    }
    return false;
  }
  
  // --------------------------------------------------
  componentDidUpdate() {
    this.shouldSecondFirstActivate();
  }
  
  componentDidMount() {
    this.shouldSecondFirstActivate();
    window.addEventListener('resize', this.onResize, false);
    // window.addEventListener('blur', this.onBlur, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    // window.removeEventListener('blur', this.onBlur);
    Object.values(this.timer).map(id => (clearTimeout(id)));
  }
  
  // --------------------------------------------------
  /**
   * 各カテゴリのコンテントを表示するための DOM 要素を返す
   */
  renderContainers() {
    const { currentFilterId } = this.state;
    const { result, index } = this.hasSecondItems(currentFilterId);
    this.getCurrentCategoryContent(this.categories, currentFilterId)
    const current = result ?
      [this.containers.second[index]]:
      this.containers.concat.filter(data => (data.name === currentFilterId));
    // @type {array} filter id に該当する `PickerContainer` を探す
    // const current = this.containers.concat.filter(data => (data.parent === currentFilterId || data.name === currentFilterId));
    if (!current.length) {
      return null;
    }
    // ---
    const {
      layout,
      pcDisplayLine,
      mbDisplayLine,
      readMoreLabel,
      selectTextColor,
    } = this.props;
    // ---
    // 配列から data を取り出す
    const data = current.shift();
    // const divided = currentFilterId.split('-');
    // const [ keyName, parentIndex, childName ] = divided;
    const component = data.category;
    const { containerIndex, filterChangeOpacityClassName } = this.state;
    const currentContainerIndex = containerIndex < 0 ? 0 : parseInt(containerIndex, 10);
    // console.log(`FeatureCategories.renderContainers filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, currentFilterId, current);
    // ---
    const props = Object.assign({}, component.props);
    return (
      <FeatureCategoryContainer
        {...props}
        showTitle={false}
        currentFilterId={currentFilterId}
        filterId={currentFilterId}
        currentContainerIndex={currentContainerIndex}
        layout={layout}
        pcDisplayLine={pcDisplayLine}
        mbDisplayLine={mbDisplayLine}
        hasSecond={false}
        readMoreLabel={readMoreLabel}
        selectTextColor={selectTextColor}
        // filterChangeOpacityClassName={filterChangeOpacityClassName}
        abortOpacityZero={this.abortOpacityZero}
        changedFilter={this.changedFilter}
        slickThumbnailChangedCallback={this.slickThumbnailChangedCallback}
      />
    );
  }
  
  // --------------------------------------------------
  // filter
  /**
   * 各カテゴリーを表示するための DOM 要素を返す
   */
  renderFilterFirst() {
    const { first } = this.containers;
    // title 不正値除く
    const firstTitles = first.filter(data => (!!data.category.props.title));
    if (!firstTitles.length) {
      return null;
    }
    if (!first.length) {
      return null;
    }
    const { currentFilterId, currentFilterMarkedId } = this.state;
    this.filterFirstTitles = {};
    return (
      <div
        className="FeatureCategories__filter__first"
        ref={component => (this.refFilterFirst = component)}
      >
        <div
          className="FeatureCategories__filter__first__title__wrap"
          ref={component => (this.refFilterFirstWrap = component)}
        >
          {
            firstTitles.map((data, index) => {
              const component = data.category;
              // console.log('FeatureCategories.renderFilterFirst.map', index, component);
              const id = data.name;
              const { result } = this.hasSecondItems(id);
              const props = Object.assign({}, component.props);
              return (
                <FeatureCategoryContainer
                  key={id}
                  {...props}
                  showTitle
                  currentFilterId={currentFilterId}
                  currentFilterMarkedId={currentFilterMarkedId}
                  filterId={id}
                  filterIndex={index}
                  titleClickCaller={this.onTitleClickCaller}
                  hasSecond={result}
                  ref={component => (this.filterFirstTitles[id] = component)}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
  /**
   * filter second PC
   * @returns {ReactElement} `div.FeatureCategories__filter__second-pc`
   */
  renderFilterSecondPc() {
    const { second } = this.containers;
    const { currentFilterId, currentFilterMarkedId } = this.state;
    // console.log('FeatureCategories.renderFilterSecondPc', currentFilterId, second, this.state);
    const filtered = second
      .filter(data => (data.parent === currentFilterId || data.name === currentFilterId || FeatureCategories.secondFilterContains(data.parent, currentFilterId)))
      // title 不正値除く
      .filter(data => (!!data.category.props.title));
    if (!filtered.length) {
      return null;
    }
    return (
      <div className="FeatureCategories__filter__second-pc">
        {
          filtered.map((data, index) => {
            const component = data.category;
            const id = data.name;
            const props = Object.assign({}, component.props);
            return (
              <FeatureCategoryContainer
                key={id}
                {...props}
                showTitle
                currentFilterId={currentFilterId}
                currentFilterMarkedId={currentFilterMarkedId}
                filterId={id}
                filterIndex={index}
                titleClickCaller={this.onTitleClickCaller}
                hasSecond={false}
              />
            );
          })
        }
      </div>
    );
  }
  /**
   * filter second MB
   * @returns {ReactElement} `div.FeatureCategories__filter__second-mb`
   */
  renderFilterSecondMb() {
    const { second } = this.containers;
    const {
      currentFilterId,
      filterTitle,
      filterSecondOpen,
      currentFilterMarkedId,
    } = this.state;
    // ---
    const filtered = second
      .filter(data => (data.parent === currentFilterId || data.name === currentFilterId || FeatureCategories.secondFilterContains(data.parent, currentFilterId)))
      // title 不正値除く
      .filter(data => (!!data.category.props.title));
    if (!filtered.length) {
      return null;
    }
    const openedClass = filterSecondOpen ? 'FeatureCategories__filter__second__opened' : '';
    const filterSelectedTitle = filterTitle || filtered[0].category.props.title;
    return (
      <div className={`FeatureCategories__filter__second-mb ${openedClass}`}>
        <div className="FeatureCategories__filter__second__heading">
          <div
            className="FeatureCategories__filter__second__heading__title__set"
            dangerouslySetInnerHTML={{__html: convertPipeToBrTag(filterSelectedTitle)}}
          />
          {
            (filtered.length > 1) ?
              <button
                className="FeatureCategories__filter__second__heading__btn"
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  // const opposite = !filterSecondOpen;
                  // toggle open / close
                  this.setState({ filterSecondOpen: !filterSecondOpen });
                }}
              /> :
              <span className="FeatureCategories__filter__second__heading__btn__margin" />
          }
        </div>
        <div className="FeatureCategories__filter__second__title__list">
          <div className="FeatureCategories__filter__second__title__wrap">
            {
              filtered.map((data, index) => {
                const component = data.category;
                const id = data.name;
                const props = Object.assign({}, component.props);
                return (
                  <FeatureCategoryContainer
                    key={id}
                    {...props}
                    showTitle
                    currentFilterId={currentFilterId}
                    currentFilterMarkedId={currentFilterMarkedId}
                    filterId={id}
                    filterIndex={index}
                    titleClickCaller={this.onTitleClickCaller}
                    parentFilter={data.parent}
                    hasSecond={false}
                  />
                );
              })
            }
          </div>
          <button
            className="FeatureCategories__filter__second__title__list__btn__close"
            type="button"
            onClick={(event) => {
              event.preventDefault();
              this.setState({ filterSecondOpen: false });
            }}
          />
        </div>
      </div>
    );
  }
  
  // render filter
  renderFilterSecond() {
    const pc = this.renderFilterSecondPc();
    const mb = this.renderFilterSecondMb();
    if (!pc && !mb) {
      return null;
    }
    return (
      <div className="filter__seconds__root">
        {pc}
        {mb}
      </div>
    );
  }
  
  renderFilters() {
    const filterFirst = this.renderFilterFirst();
    const filterSecond = this.renderFilterSecond();
    if (!filterFirst && !filterSecond) {
      return null;
    }
    return (
      <div className="FeatureCategories__filter">
        {filterFirst}
        {filterSecond}
      </div>
    );
  }
  
  // --------------------------------------------------
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      selectTextColor,
      layout,
    } = this.props;
    // ---
    const categories = this.categories;
    // console.log('FeatureCategories.render', categories);
    if (!categories.length) {
      return null;
    }
    // ---
    const textColorClass = `selectTextColor__${(selectTextColor || 'Dark').toLowerCase()}`;
    const layoutClass = `layout__${(layout || 'Horizontal').toLowerCase()}`;
    // const slickTransitionClass = this.slickTransitionZero ? this.abortSlickTransitionClassName : '';
    const { slickTransitionClassName, filterChangeOpacityClassName } = this.state;
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div className={`FeatureCategories ${textColorClass} ${layoutClass} ${slickTransitionClassName} ${filterChangeOpacityClassName}`}>
            {/* カテゴリメニューを表示する */}
            {this.renderFilters()}
            {/* 各カテゴリのコンテントを表示する */}
            {this.renderContainers()}
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/feature-categories/index.jsx